// extracted by mini-css-extract-plugin
module.exports =  {"checkbox-wrapper":"RHTEfJ9","checkboxWrapper":"RHTEfJ9"};